<router-outlet />

<hub-loading-spinner [mainLoader]="true" />
